import React, { useState } from 'react';
import ReactDOM from 'react-dom';

// Styles & Assets
import styles from './ColorSelector.module.css';

// Hooks
import useTooltip from '../../../hooks/useTooltip';
import useClickOutside from '../../../hooks/useClickOutside';

// Interfaces
interface ColorOption {
    id: number;
    color: string;
}

interface Props {
    options: ColorOption[];
    defaultColor?: string;
    onClick: (id: number) => void;
}

const ColorSelector: React.FC<Props> = ({ options, defaultColor = '#fff', onClick }) => {
    const [showOptions, setShowOptions] = useState(false);

    const handleClickButton = (e: React.MouseEvent) => {
        e.preventDefault();
        setShowOptions(value => !value);
    };

    const handleClickOption = (id: number) => (e: React.MouseEvent) => {
        e.preventDefault();
        setShowOptions(false);
        onClick(id);
    };

    const setFalse = () => setShowOptions(false);

    const getStylePos = (pos: DOMRect, element: HTMLInputElement) => {
        return {
            top: `${pos.bottom}px`,
            left: `${pos.left + element.offsetWidth / 2}px`,
            width: `${element.offsetWidth}px`
        };
    };

    const { tooltipRef, getStyles } = useTooltip(getStylePos);
    const wrapperRef = useClickOutside(setFalse, tooltipRef);

    return (
        <div className={styles.wrapper} ref={tooltipRef}>
            <div className={styles.container}>
                <button className={styles.buttonSelect} onClick={handleClickButton}>
                    <div className={styles.option} style={{ background: defaultColor }} />
                </button>

                {showOptions
                    ? ReactDOM.createPortal(
                        <div
                            className={styles.optionsContainer}
                            style={getStyles() ?? undefined}
                            ref={wrapperRef}
                        >
                            {options.map(option => (
                                <button
                                    key={option.id}
                                    className={styles.option}
                                    style={{ background: option.color }}
                                    onClick={handleClickOption(option.id)}
                                />
                            ))}
                        </div>,
                        document.getElementById('tooltip') as HTMLElement
                    )
                    : null}
            </div>
        </div>
    );
};

export default ColorSelector;